import type { MessageToolDocument } from "@virtual-brain-lib/types";

export const UNLABELED_KEY = "__unlabeled__";

export interface DocumentGroup {
	key: string;
	label: string | undefined;
	documents: MessageToolDocument[];
}

export function groupDocumentsBySourceLabel(
	documents: readonly MessageToolDocument[],
): readonly DocumentGroup[] {
	const map = new Map<string, DocumentGroup>();

	for (const doc of documents) {
		const key = doc.sourceLabel ?? UNLABELED_KEY;
		const existing = map.get(key);

		if (existing) {
			existing.documents.push(doc);
			continue;
		}

		map.set(key, { key, label: doc.sourceLabel, documents: [doc] });
	}

	const groups = Array.from(map.values());

	groups.sort((a, b) => {
		if (a.key === UNLABELED_KEY) {
			return 1;
		}

		if (b.key === UNLABELED_KEY) {
			return -1;
		}

		return 0;
	});

	return groups;
}
